import {
  createStyles,
  Grid,
  Theme,
  Typography,
  withStyles,
  WithStyles,
  Button,
  Hidden,
  IconButton,
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import React, { Component } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import NavBarDrawer from './NavBarDrawer';
const logo = 'https://www.app.aisensy.com/static/media/full_logo.5c8cd2004689fd2d18de.png';

class NavBarMobile extends Component<Props, cState> {
  static defaultProps = {
    // name: 'AiSensy',
  };
  state = {
    drawerOpen: false,
  };
  onDrawerOpen = () => {
    this.setState({ drawerOpen: true });
  };
  onDrawerClose = () => {
    this.setState({ drawerOpen: false });
  };
  render(): React.ReactElement {
    const { classes } = this.props;
    const path = this.props.location.pathname;
    return (
      <Grid container alignItems="center" style={{ height: 60 }}>
        <Grid item>
          <IconButton onClick={this.onDrawerOpen}>
            <Menu />
          </IconButton>
        </Grid>
        <Grid item>
          <a
            href="https://aisensy.com"
            style={{ display: 'block', height: '34px' }}
            target="_blank"
            rel="noreferrer"
          >
            <img src={logo} className={classes.logo} />
          </a>
        </Grid>
        {/* <Grid item>
          <Button 
            color="primary"
            style={{borderRadius: 25}}
            component={Link}
            to="/generate-whatsapp-link"
          >
            WhatsApp Link
          </Button>	
        </Grid> */}
        <Grid item>
          <ActiveBtn path={path} classes={classes} />
        </Grid>
        <NavBarDrawer
          drawerOpen={this.state.drawerOpen}
          onDrawerClose={this.onDrawerClose}
        />
      </Grid>
    );
  }
}

const ActiveBtn = (props: {
  path: string;
  classes: any;
}): React.ReactElement => {
  switch (props.path) {
    case '/generate-whatsapp-link':
      return (
        <Button
          color="primary"
          className={props.classes.activeBtn}
          component={Link}
          to="/generate-whatsapp-button"
          variant="outlined"
          size="small"
        >
          WhatsApp Button
        </Button>
      );
    case '/generate-whatsapp-button':
      return (
        <Button
          color="primary"
          className={props.classes.activeBtn}
          component={Link}
          to="/generate-whatsapp-link"
          variant="outlined"
          size="small"
        >
          WhatsApp Link
        </Button>
      );
    default:
      return (
        <Button
          color="primary"
          className={props.classes.activeBtn}
          variant="outlined"
          size="small"
          href="https://app.aisensy.com/signup"
          target="_blank"
        >
          Sign Up
        </Button>
      );
  }
};

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  // name: string,
  // number: string
}

interface cState {
  drawerOpen: boolean;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: 60,
      width: '100vw',
      position: 'sticky',
      top: 0,
      left: 0,
      // backgroundColor: "#EBF5F3",
      backgroundColor: '#ffffff',
      boxShadow: 'rgb(0 0 0 /10%) 0px 0px 0.428571rem 0px',
      // backgroundColor: theme.palette.primary.main,
      // paddingLeft: theme.spacing(2),
      boxSizing: 'border-box',
      zIndex: 100,
      // color: "white"
      // boxShadow: "0px 0px 2px 2px lightgrey"
    },
    logo: {
      height: 50,
      // marginRight: 40,
      [theme.breakpoints.down('md')]: {
        marginRight: 90,
        // width: 90,
        // marginLeft: 10,
        height: 34,
      },
      [theme.breakpoints.down(376)]: {
        marginRight: 40,
      },
      [theme.breakpoints.down(321)]: {
        marginRight: 0,
      },
    },
    activeBtn: {
      borderRadius: 25,
      marginRight: 0,
    },
  });

export default withStyles(styles)(withRouter(NavBarMobile));
